import QuestionAnswersPrefillRed1 from './question-answers-red-1.json';
import QuestionAnswersPrefillRed2 from './question-answers-red-2.json';
import QuestionAnswersPrefillRed3 from './question-answers-red-3.json';

export default [
  QuestionAnswersPrefillRed1,
  QuestionAnswersPrefillRed2,
  QuestionAnswersPrefillRed3,
];
